export function calculateTDEE({ weight, height, age, gender, activityLevel }) {
  const bmr = gender === 'male'
    ? 10 * weight + 6.25 * height - 5 * age + 5
    : 10 * weight + 6.25 * height - 5 * age - 161;

  const multipliers = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    veryActive: 1.9,
  };
  return Math.round(bmr * (multipliers[activityLevel] || 1.55));
}

export function calculateMacros({ tdee, goal }) {
  const adjustments = {
    weight_loss: -400,
    maintenance: 0,
    muscle_gain: 300,
    performance: 500,
  };
  const calories = tdee + (adjustments[goal] || 0);
  return {
    calories,
    protein: Math.round((calories * 0.30) / 4),
    carbs: Math.round((calories * 0.45) / 4),
    fat: Math.round((calories * 0.25) / 9),
  };
}

export function calculateWilks({ bodyweight, total, gender }) {
  const coeff = gender === 'male'
    ? [-216.0475144, 16.2606339, -0.002388645, -0.00113732, 7.01863e-6, -1.291e-8]
    : [594.31747775582, -27.23842536447, 0.82112226871, -0.00930733913, 0.00004731582, -0.00000009054];
  const bw = bodyweight;
  const denom = coeff[0] + coeff[1] * bw + coeff[2] * bw ** 2 + coeff[3] * bw ** 3 + coeff[4] * bw ** 4 + coeff[5] * bw ** 5;
  return Math.round((500 / denom) * total);
}

export function getBMI({ weight, height }) {
  const h = height / 100;
  return (weight / (h * h)).toFixed(1);
}

export function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'GOOD MORNING';
  if (hour < 17) return 'GOOD AFTERNOON';
  return 'GOOD EVENING';
}
